import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';

import Accordion, { AccordionItem } from '../@base/Accordion';
import Input from '../@base/Input';
import TextArea from '../@base/TextArea';
import {
  preparingInput, getParameter, onValidHandler, handleInputValid,
} from './Commons';

import styles from './SharedStyle.module.css';

const RepetitionComponent = (props) => {
  if (!props.component.parameters) return null;

  const parameterList = props.component.parameters;

  let similarity = getParameter(parameterList, 'repetition.minimum.similarity');
  let repetitions = getParameter(parameterList, 'repetition.number.of.repetitions');
  const message = getParameter(parameterList, 'repetition.answer');

  similarity.value = similarity.value ? similarity.value : 0;
  repetitions.value = repetitions.value ? repetitions.value : 0;
  message.value = message.value ? message.value : '';

  const [inputValid, setInputValid] = useState({});

  const adjustMaxMinParametersValues = () => {
    similarity = getParameter(parameterList, 'repetition.minimum.similarity');
    repetitions = getParameter(parameterList, 'repetition.number.of.repetitions');

    if (similarity.value > 1) similarity.value = 1;
    else if (similarity.value < 0.5) similarity.value = 0.5;
    if (repetitions.value > 10) repetitions.value = 10;
    else if (repetitions.value < 2) repetitions.value = 2;

    similarity.value = similarity.value.toString();

    props.updateParameter({ ...similarity });
    props.updateParameter({ ...repetitions });
  };

  useEffect(() => {
    handleInputValid(inputValid, props);
  }, [inputValid]);

  useEffect(() => {
    const helperContent = (
      <div>
        {ReactHtmlParser(`${props.component.description} Nesse componente podem ser configurados:`)}
        <ul>
          <li>{ReactHtmlParser(message.parameter.hint)}</li>
          <li>{ReactHtmlParser(similarity.parameter.hint)}</li>
          <li>{ReactHtmlParser(repetitions.parameter.hint)}</li>
        </ul>
      </div>
    );
    props.setHelperContent(helperContent);

    return () => {
      adjustMaxMinParametersValues();
    };
  }, []);

  return (
    <Accordion>
      <AccordionItem active title={message.parameter.hint}>
        <div>Mensagem de resposta à repetição detectada</div>
        <div className={styles.ComponentSubList}>
          {preparingInput(<TextArea placeholder="Digite a mensagem para repetição" />,
            message,
            props,
            onValidHandler(setInputValid, message))}
        </div>
      </AccordionItem>
      <AccordionItem active>
        <div>Configurações </div>
        <div className={styles.ComponentSubList} style={{ textAlign: 'left' }}>
          <div className="item-list">
            <div className="row">
              {preparingInput(<Input
                label="Mínimo de semelhança (%)"
                labelWidth={170}
                width={80}
                inline
                number
                percent
                min={50}
                max={100}
                title={similarity.parameter.hint}
              />, similarity, props, onValidHandler(setInputValid, similarity))}
            </div>
            <div />
          </div>
          <div className="item-list">
            <div className="row">
              {preparingInput(<Input
                label="Máximo de repetições"
                labelWidth={170}
                width={80}
                inline
                number
                min={2}
                max={10}
                title={repetitions.parameter.hint}
              />, repetitions, props, onValidHandler(setInputValid, repetitions))}
            </div>
            <div />
          </div>
        </div>
      </AccordionItem>
      {props.localizationAccordionItem || null}
      {/* <AccordionItem>
        <div>Como funciona</div>
        <div>
          {ReactHtmlParser(props.component.description)}
          . Nesse componente podem ser configurados:
          <ul>
            <li>
              {ReactHtmlParser(message.parameter.hint)}
            </li>
            <li>
              {ReactHtmlParser(similarity.parameter.hint)}
            </li>
            <li>
              {ReactHtmlParser(repetitions.parameter.hint)}
            </li>
          </ul>
        </div>
      </AccordionItem> */}
    </Accordion>
  );
};

export default RepetitionComponent;
